import BaseRestService from "../../Service/BaseRestService";

const UNSPLASH_KEY = "lTcsEt6MpSPe5fIA6ghtQHkTCLRcyGWoMNFEZt99-aQ";

class Unsplash extends BaseRestService {
  async searchImages(search, page, color, orientation, perPage = 28) {
    let url = `https://api.unsplash.com/search/photos?per_page=${perPage}&page=${page}&client_id=${UNSPLASH_KEY}`;

    if (color) {
      url += `&color=${color.value}`;
    }
    if (orientation) {
      url += `&orientation=${orientation}`;
    }
    if (search) {
      url += `&query=${search}`;
    } else {
      url += `&query=city`;
    }

    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async trackDownload(url) {
    const downloadLink = `${url}&client_id=${UNSPLASH_KEY}`;

    return this.client.get(downloadLink, await this.buildJWTAuthAxiosConfig());
  }
}

export const UnsplashService = new Unsplash();

export const getPageById = async (pageId) =>
  new Promise((resolve) => {
    window.AP.request({
      method: "GET",
      url: `/rest/api/content/search?cql=type=page and id=${pageId}`,
      success: (res) => {
        const { results } = JSON.parse(res);
        if (results.length) {
          // Find by id
          const currentPage = results.find((result) => result.id === pageId);
          if (!currentPage) resolve({});

          resolve({
            label: currentPage.title,
            value: currentPage.id,
          });
        } else {
          resolve({});
        }
      },
      error: () => {
        resolve({});
      },
    });
  });

export const getPages = async () =>
  new Promise((resolve) => {
    window.AP.request({
      method: "GET",
      url: "/rest/api/search?cql=type=page",
      success: (res) => {
        const { results } = JSON.parse(res);
        const pages = results.map((page) => ({
          label: page.content.title,
          value: page.content.id,
        }));
        resolve(pages);
      },
      error: () => {
        resolve([]);
      },
    });
  });

export const searchPages = async (input) =>
  new Promise((resolve) => {
    const url = !input
      ? `/rest/api/content/search?cql=type=page and title ~ "*"`
      : `/rest/api/content/search?cql=type=page and title ~ "${input}*"`;
    window.AP.request({
      method: "GET",
      url,
      success: (res) => {
        const { results } = JSON.parse(res);
        const pages = results.map((page) => ({
          label: page.title,
          value: page.id,
        }));
        resolve(pages);
      },
      error: () => {
        resolve([]);
      },
    });
  });

const fetchAttachments = async (
  { pageId, contentType },
  attachments = [],
  cursor
) => {
  const url = `/api/v2/${
    contentType === "page" ? "pages" : "blogposts"
  }/${pageId}/attachments?limit=250${cursor ? `&cursor=${cursor}` : ""}`;

  try {
    const response = await window.AP.request(url);
    const data = JSON.parse(response.body);
    if (data?.results?.length) {
      attachments.push(...data.results);
    }

    if (data?._links?.next) {
      const url = new URL(
        data._links.base.replace("/wiki", "") + data._links.next
      );
      const _cursor = url.searchParams.get("cursor");
      if (_cursor) {
        return await fetchAttachments(
          { pageId, contentType },
          attachments,
          _cursor
        );
      }
    }
    return attachments;
  } catch (error) {
    console.log("Error while fetching attachments ", error);
    return attachments;
  }
};

export const getPageAttachments = async (pageId, contentType) => {
  try {
    const attachments = await fetchAttachments({ pageId, contentType });

    return attachments.filter((att) =>
      [
        "video/mp4",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/webp",
        "application/octet-stream",
      ].includes(att.mediaType)
    );
  } catch (error) {
    return [];
  }
};
